import { ActionTitle } from "@/components/actionTitle/ActionTitle";
import { ActionTitleActions } from "@/components/actionTitle/ActionTitleActions";
import { useActiveProject } from "@/features/project/ActiveProject";
import { getAllDraftOrdersIds, useDraftOrderSearchByPartyId } from "@repo/api";
import { ListView, ListViewItem, createNewIcon } from "@repo/skapa";
import { plusIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { PaddedContainer, useSettings } from "@repo/ui";
import { Line } from "@repo/ui";
import { SectionContainer } from "@repo/ui";
import { trackAnalytics } from "@repo/utils";
import { hasItems } from "@repo/utils";
import { useState } from "react";

import { handleCreateOrder } from "../utils";
import { DraftOrders } from "./DraftOrders";
import { AddDraftOrderModal } from "./addDraftOrder/AddDraftOrderModal";

export const DraftOrdersSection = ({ editable }: { editable: boolean }) => {
  const { market, language } = useSettings();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [
    showUnLinkedDraftOrderOverlayItems,
    setShowUnLinkedDraftOrderOverlayItems,
  ] = useState<boolean>(false);

  const { opportunity } = useActiveProject();
  const draftOrderIds = getAllDraftOrdersIds(opportunity);
  const { data: customerDraftOrders } = useDraftOrderSearchByPartyId(
    opportunity?.partyId
  );

  const unassociatedDraftOrders = customerDraftOrders?.filter((res) => {
    return !draftOrderIds.includes(res?.draftOrderId);
  });

  return (
    <PaddedContainer>
      <SectionContainer>
        <ActionTitle
          title={`${
            draftOrderIds.length > 1
              ? t("label.draft_orders")
              : t("label.draft_order")
          } (${draftOrderIds.length})`}
          action={
            editable && (
              <ActionTitleActions
                actions={[
                  {
                    id: "create-order-action",
                    icon: createNewIcon,
                    onClick: () => {
                      if (opportunity) {
                        handleCreateOrder(opportunity, market, language);
                        trackAnalytics("create_order");
                      }
                    },
                    text: t("action.create_order"),
                    title: t("action.create_order"),
                    iconOnly: true,
                  },
                  {
                    id: "add-draft-order-action",
                    icon: plusIcon,
                    onClick: () => {
                      setIsOpen(true);
                      trackAnalytics("add_draftOrder");
                    },
                    text: t("action.add_draft_orders"),
                    title: t("action.add_draft_orders"),
                    iconOnly: true,
                  },
                ]}
              />
            )
          }
        />

        <DraftOrders editable={editable} />
      </SectionContainer>

      {hasItems(unassociatedDraftOrders) && (
        <ListView id="disassociated-draftOrder-list" size="small">
          <Line />
          <ListViewItem
            control={editable ? "navigational" : "default"}
            onClick={() => {
              setShowUnLinkedDraftOrderOverlayItems(true);
              setIsOpen(true);
              trackAnalytics("add_disassociated_draftOrder");
            }}
            title={
              unassociatedDraftOrders.length > 1
                ? t("prompt.found_multiple_draft_orders_not_associated", {
                    total: unassociatedDraftOrders.length,
                  })
                : t("prompt.found_one_draft_order_not_associated")
            }
          />
        </ListView>
      )}
      {isOpen && (
        <AddDraftOrderModal
          isOpen={isOpen}
          closeModal={() => {
            setIsOpen(false);
            setShowUnLinkedDraftOrderOverlayItems(false);
          }}
          associatedDraftOrders={draftOrderIds}
          showUnLinkedDraftOrderOverlayItems={
            showUnLinkedDraftOrderOverlayItems
          }
        />
      )}
    </PaddedContainer>
  );
};
